import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { shouldForceOtroDocumentoProbatorio } from '@/utils/nemonIntegration';
import { tiposUsuarioValidos } from '@/utils/constants';

export const ForceOtroDocumentoProbatorioEffect = ({ countries }) => {
  const { values, setFieldValue } = useFormikContext();

  const selectedCountry = countries.find(
    c => c.PkPaises === values.FkPaises
  );

  const forceOtroDocumentoProbatorio =
    selectedCountry
      ? shouldForceOtroDocumentoProbatorio(
          selectedCountry.Codigo,
          selectedCountry?.EsIntracomunitario,
        values.EsEmpresa
        )
      : false;

  useEffect(() => {
    if (forceOtroDocumentoProbatorio) {
      setFieldValue('OtroDocumentoProbatorio', true);
    }
  }, [forceOtroDocumentoProbatorio, setFieldValue]);

  return null; // no renderiza nada
};